import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { LoaderService } from '../../../../shared/sharedServices/loader.service';
import { SharedService } from '../../../../shared/sharedServices/shared.service';
import { ARTIFACT_COLS } from './province-columns';

@Component({
  selector: 'kt-province-details',
  templateUrl: './province-details.component.html',
  styleUrls: ['./province-details.component.scss']
})
export class ProvinceDetailsComponent implements OnInit {

  public columnDef: any;
  public artifactData:Array<any> = []

  constructor(private dialogRef: MatDialogRef<ProvinceDetailsComponent>, 
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private sharedService: SharedService,
    private loaderService: LoaderService,) { }

  ngOnInit() {
    console.log(this.data);
    this.artifactData = this.data.data
    this.generateColumns()
  }

  onClose(): void {
		this.dialogRef.close();
	}

  private generateColumns()
	{

      this.columnDef =ARTIFACT_COLS
	}

}
